import './SmsAndGridRadio.less';

import React from 'react';
import RadioButton from '../../forms/RadioButton';
import { METHOD_2FA_GRID, METHOD_2FA_SMS } from './method';
import { makeField } from 'nike-form-js';
import { PATH } from '../util/paths';
import { useReframe } from 'nike-re-framejs';
import i18n from '../../../common/i18n';

const SmsAndGridRadio = ({ availableMethods, form }) => {
    const { deref } = useReframe();
    const methodField = makeField(form, PATH.METHOD);
    const methodValue = deref(methodField.getValue());
    function setMethod(method) {
        methodField.setValue(method);
    }

    return (
        <>
            {availableMethods.includes(METHOD_2FA_SMS) ? (
                <RadioButton
                    active={methodValue === METHOD_2FA_SMS}
                    className="two-factor-ver-radio-box"
                    onClick={() => setMethod(METHOD_2FA_SMS)}
                    dataAtid="two-factor-sms-radio"
                >
                    {i18n('nui.two.fa.sms')}
                </RadioButton>
            ) : null}
            {availableMethods.includes(METHOD_2FA_GRID) ? (
                <RadioButton
                    active={methodValue === METHOD_2FA_GRID}
                    className="two-factor-ver-radio-box"
                    onClick={() => setMethod(METHOD_2FA_GRID)}
                    dataAtid="two-factor-grid-radio"
                >
                    {i18n('nui.two.fa.grid')}
                </RadioButton>
            ) : null}
        </>
    );
};

export default SmsAndGridRadio;
